<template>
  <div class="shipments">
    <PageMenu :linksList="linksComputedList" />
    <router-view />
  </div>
</template>

<script>
/* eslint-disable */
import {mapGetters} from 'vuex';
import PageMenu from '@/components/global/pageMenu';

export default {
  name: 'PickupsIndex',
  components: { PageMenu },
  computed: {
    ...mapGetters([
      'get_user_permission',
    ]),
    linksComputedList() {
      return [
        {
          name: 'booked_pickup',
          link: '/pickups/booked',
          visible: this.get_user_permission('pickup/booked').view,
        },
        {
          name: 'not_planned_pickup',
          link: '/pickups/not-planned',
          visible: this.get_user_permission('pickup/not-planned').view,
        },
      ]
    },
  },
};
</script>
